import axios from "axios";
import URL from '../constants/ServerUrl'

const axiosInstance = axios.create({
    baseURL: URL, // Replace with your API base URL
    timeout: 10000, // Set a timeout for requests in milliseconds
});

const apiConnector = async (
    method
    , url
    , bodyData
    , headers
    , params
) => {
    return axiosInstance({
        method: `${method}`,
        url: `${url}`,
        data: bodyData ? bodyData : {},
        headers: headers ? headers : {},
        params: params ? params : {},
    });
};

export default apiConnector
